import {
  Card,
  FilterIcon,
  GKButton,
  Grid2,
  NoData,
  RightIcon,
  StrokeIcon,
  Tooltip,
  Typography,
} from "components";
import { useMemo, useState } from "react";
import { numberToCurrency } from "utils";
import { PieChartColors } from "utils/constants";
import FilterModal from "./FilterModal";
import PortfolioBreakdownContent from "./PortfolioBreakdownContent";

interface PortfolioBreakdownProps {
  allHoldingsInsightsData: any;
  portfolioList?: any[];
  selectedItems?: any[];
  selectedAssetTypes?: string[];
  onApply?: (selectedPortfolios: any[], assetTypes: string[]) => void;
}

const PortfolioBreakdown = ({
  allHoldingsInsightsData,
  portfolioList,
  selectedItems,
  selectedAssetTypes,
  onApply,
}: PortfolioBreakdownProps) => {
  const [pieData, setPieData] = useState<any>([]);

  const [isModalOpen, setIsModalOpen] = useState(false);

  console.log(selectedItems, "selectedItemsselectedItems");

  // const [pieClickData, setPieClickData] = useState<any>();
  // const [pieHoverData, setPieHoverData] = useState<any>();
  const [currentValueTabs, setCurrentValueTabs] = useState(0);

  const { uniqueStocksCount, overlappingStocksCount } = useMemo(() => {
    let unique = 0;
    let overlap = 0;

    allHoldingsInsightsData?.forEach((item: any) => {
      if (item.countPortfolios === 0 || item.countPortfolios === 1) {
        unique++;
      } else if (item.countPortfolios >= 2) {
        overlap++;
      }
    });

    return {
      uniqueStocksCount: unique,
      overlappingStocksCount: overlap,
    };
  }, [allHoldingsInsightsData]);

  const checkCurrentValue = (sum: any, current: any) =>
    currentValueTabs === 0
      ? sum + current?.currentAmount
      : sum + current?.investedAmount;

  const totalInvestment = allHoldingsInsightsData?.reduce(
    (sum: any, current: any) => checkCurrentValue(sum, current),
    0,
  );

  const sectorsArray = () =>
    allHoldingsInsightsData.map((item: any) => ({
      sector: item.instType,
      companyName: item.asset.name,
      investedAmount: item.investedAmount,
      companyPercentage:
        currentValueTabs === 0
          ? (item.currentAmount / totalInvestment) * 100
          : (item.investedAmount / totalInvestment) * 100,
    }));

  const cumulativeSectorsWithPercentage = () =>
    sectorsArray()?.reduce((acc: any, current: any) => {
      const x = acc.find((item: any) => item.sector === current.sector);
      if (!x) {
        return acc.concat([current]);
      }
      return acc?.map((item: any) =>
        item.sector === current.sector
          ? {
              ...item,
              companyPercentage:
                item.companyPercentage + current.companyPercentage,
            }
          : item,
      );
    }, []);

  useMemo(() => {
    // pie data set
    setPieData(
      cumulativeSectorsWithPercentage()
        ?.map((item: any) => {
          const { sector } = item;
          const data = {
            id: sector,
            value: +item.companyPercentage,
            color: "",
          };

          return data;
        })
        ?.sort((a: any, b: any) => b.value - a.value)
        ?.map((item: any, index: number) => {
          return {
            ...item,
            color: PieChartColors[index < 12 ? index : index % 12],
          };
        }),
    );
    // defaultData();
  }, [allHoldingsInsightsData, currentValueTabs === 0]);

  return (
    <>
      {!allHoldingsInsightsData?.length ? (
        <NoData
          customImg={
            <img
              loading="lazy"
              alt=""
              src="/LandingPage/portfolio.svg"
              draggable={false}
            />
          }
          additionalComponent={
            <GKButton
              variant="contained"
              startIcon={<FilterIcon />}
              endIcon={<RightIcon />}
              onClick={() => {
                setIsModalOpen(true);
              }}
            >
              Select Portfolios
            </GKButton>
          }
          text="No Insights Data Available"
          subText="Select portfolios to view allocation and holding insights."
        />
      ) : (
        <Card sx={{ p: 0 }}>
          <Grid2
            container
            sx={{
              p: 1.5,
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              borderBottom: "1px solid",
              borderColor: "#E3E8EF",
            }}
          >
            <Typography fontSize={14} fontWeight={700} color="#333">
              Portfolio Breakdown
            </Typography>
            <Typography fontSize={14} fontWeight={700} color="#333">
              {numberToCurrency(
                allHoldingsInsightsData?.reduce(
                  (sum: number, item: any) => sum + (item?.currentAmount || 0),
                  0,
                ),
              )}
            </Typography>
          </Grid2>
          <Grid2>
            <Grid2
              size={12}
              p={2}
              display="flex"
              alignItems="center"
              justifyContent="space-between"
            >
              <Grid2 size={3}>
                <PortfolioBreakdownContent
                  data={pieData?.filter((data: any) => data?.value !== 0)}
                />
              </Grid2>
              <Grid2 size={4}>
                <div
                  style={{
                    maxHeight: 190,
                    overflow: "auto",
                    marginTop: "10px",
                  }}
                >
                  {pieData?.map((legends: any) => (
                    <Grid2
                      container
                      key={legends.id}
                      alignItems="center"
                      justifyContent="space-between"
                      style={{
                        fontWeight: "600",
                        borderRadius: "4px",
                        // backgroundColor:
                        //   pieClickData && pieClickData?.id === legends.id
                        //     ? "var(--neutral-100)"
                        //     : "transparent",
                        // color:
                        //   pieHoverData?.id === legends.id
                        //     ? "var(--primary-500)"
                        //     : "var(--neutral-500)",
                      }}
                    >
                      <Grid2
                        size={9}
                        container
                        alignItems="center"
                        style={{ padding: "4px" }}
                      >
                        <div
                          style={{
                            width: "16px",
                            height: "16px",
                            backgroundColor: legends.color,
                            marginRight: "8px",
                          }}
                        />
                        <Tooltip title={legends.id} arrow placement="top">
                          <Typography
                            display={"flex"}
                            fontSize={12}
                            fontWeight={600}
                            textOverflow={"ellipsis"}
                            whiteSpace={"nowrap"}
                            width={"70%"}
                            overflow={"hidden"}
                            style={{
                              cursor: "pointer",
                            }}
                            onClick={() => setCurrentValueTabs(legends)}
                            // onMouseEnter={() => setPieHoverData(legends)}
                            // onMouseLeave={() => setPieHoverData(undefined)}
                          >
                            {legends.id}
                          </Typography>
                        </Tooltip>
                      </Grid2>
                      <Grid2 size={3} pl={1}>
                        <Typography
                          fontSize={12}
                          fontWeight={600}
                          color={"var(--black)"}
                          textAlign={"center"}
                        >
                          {legends?.value?.toFixed(2)}%
                        </Typography>
                      </Grid2>
                    </Grid2>
                  ))}
                </div>
              </Grid2>
              <Grid2 size={5}>
                <Card
                  sx={{
                    p: 2,
                    backgroundColor: "var(--grey-bg-100)",
                    display: "flex",
                    flexDirection: "column",
                    gap: 1,
                  }}
                >
                  <Typography
                    fontSize={12}
                    fontWeight={700}
                    color="var(--black & white/black-900)"
                  >
                    Portfolio Summary
                  </Typography>
                  <Typography
                    fontSize={12}
                    fontWeight={500}
                    color="var(--grey-700)"
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                  >
                    <span>Portfolio Value</span>
                    <span>
                      {numberToCurrency(
                        allHoldingsInsightsData?.reduce(
                          (sum: number, item: any) =>
                            sum + (item?.totalAmount || 0),
                          0,
                        ) || 0,
                      )}
                    </span>
                  </Typography>
                  <StrokeIcon height={"auto"} width={"100%"} />
                  <Typography
                    fontSize={12}
                    fontWeight={500}
                    color="var(--grey-700)"
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                  >
                    <span>Unique Stocks</span>
                    <span>{uniqueStocksCount}</span>
                  </Typography>
                  <StrokeIcon height={"auto"} width={"100%"} />
                  <Typography
                    fontSize={12}
                    fontWeight={500}
                    color="var(--grey-700)"
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                  >
                    <span>Overlapping Stocks</span>
                    <span>{overlappingStocksCount}</span>
                  </Typography>
                </Card>
              </Grid2>
            </Grid2>
          </Grid2>
        </Card>
      )}

      {isModalOpen && (
        <FilterModal
          open={isModalOpen}
          setOpen={setIsModalOpen}
          portfolioList={portfolioList}
          selectedItems={selectedItems}
          selectedAssetTypes={selectedAssetTypes}
          onApply={(selectedPortfolios, assetTypes) => {
            if (onApply) {
              onApply(selectedPortfolios, assetTypes);
            }
          }}
        />
      )}
    </>
  );
};

export default PortfolioBreakdown;
